var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"leftmenu",attrs:{"collapse":_vm.isCollapse,"router":""}},[_vm._l((_vm.expertUserMenus),function(menu,menuIndex){return [_c('el-menu-item',{key:menu.path,attrs:{"index":menu.path,"route":_vm.goRoute(menu)}},[_c('i',{staticClass:"el-icon-menu"}),_c('span',{attrs:{"sloat":"title"}},[_vm._v(_vm._s(menu.title))])])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }